import type { TActivityType } from "@/types"
import { activitiesAPI, setQueryCache } from "@/utils"
import { useAPIResource } from "./query"
import { useConfig } from "./useConfig"

export function useActivity(activityId: string) {
  const query = useAPIResource(activitiesAPI, { id: activityId, ...setQueryCache(3600e3 * 24) })
  return query
}

export function useActivityEnabled(type: TActivityType) {
  const config = useConfig()
  return !!config?.sections?.[type]?.is_active
}
